export default "__VITE_ASSET__54a2e5f6__"